import { render, staticRenderFns } from "./PersonType.vue?vue&type=template&id=7d130dee&scoped=true&"
import script from "./PersonType.vue?vue&type=script&lang=js&"
export * from "./PersonType.vue?vue&type=script&lang=js&"
import style0 from "./PersonType.vue?vue&type=style&index=0&id=7d130dee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d130dee",
  null
  
)

export default component.exports